import { MONTH_SHORT } from './constants';

export const dateDiff = (date1, date2) => {
  let [dt1Date, dt1Month, dt1Year] = date1.split('/');
  const dt2 = new Date(date2);

  dt1Month = dt1Month - 1;
  const dt1Hours = 0;

  const dt2Year = dt2.getFullYear();
  const dt2Month = dt2.getMonth();
  const dt2Date = dt2.getDate();
  const dt2Hours = dt2.getHours();

  if (dt1Year === dt2Year && dt1Month === dt2Month && dt1Date === dt2Date) {
    return (
      Math.floor(
        (Date.UTC(dt2Year, dt2Month, dt2Date, dt2Hours) -
          Date.UTC(dt1Year, dt1Month, dt1Date, dt1Hours)) /
          (1000 * 60 * 60)
      ) + ' hour(s)'
    );
  } else {
    return (
      Math.floor(
        (Date.UTC(dt2Year, dt2Month, dt2Date) -
          Date.UTC(dt1Year, dt1Month, dt1Date)) /
          (1000 * 60 * 60 * 24)
      ) + ' day(s)'
    );
  }
};

export const getDateInUSFormat = (date) => {
  if (date) {
    let [day, month, year] = date.split('/');
    const dateStr = new Date(year, month, day).toLocaleDateString('en-US');
    return dateStr ? dateStr : '';
  }
  return '';
};

export const isToday = (date) => {
  const today = new Date();
  return (
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
  );
};

export const getDateByMonthAndYear = (month, year) => {
  if (month === -1 || year === -1) {
    return 'Present';
  }

  if (!month && !year) {
    return '';
  }

  return `${MONTH_SHORT[month] || ''} ${year}`;
};
